import * as React from 'react'
import { SVGProps } from 'react'

export const BarsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={25}
    height={27}
    viewBox="0 0 25 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M5.263 26.364H1.316a1.28 1.28 0 0 1-.93-.407 1.427 1.427 0 0 1-.386-.98V13.875c0-.368.139-.721.385-.982.247-.26.582-.406.93-.406h3.948c.35 0 .684.146.93.406.247.26.386.614.386.982v11.1c0 .368-.139.721-.385.981-.247.26-.582.407-.93.407Zm9.21 0h-3.947c-.349 0-.683-.147-.93-.407a1.427 1.427 0 0 1-.385-.98V1.386c0-.367.138-.72.385-.98s.581-.407.93-.407h3.948c.349 0 .683.146.93.406s.386.614.386.982v23.588c0 .368-.14.721-.386.981-.247.26-.581.407-.93.407Zm9.211 0h-3.947a1.28 1.28 0 0 1-.93-.407 1.427 1.427 0 0 1-.386-.98V9.712c0-.368.139-.721.385-.981.247-.26.582-.407.93-.407h3.948c.35 0 .684.147.93.407.247.26.386.613.386.98v15.264c0 .368-.139.721-.385.981-.247.26-.582.407-.93.407Z"
      fill="#E600DC"
    />
  </svg>
)

export const AcademicCapIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-9 w-9"
    viewBox="0 0 27 27"
    fill="#6C86E2"
    width={27}
    height={27}
    {...props}>
    <path d="M14.032 2.808a1.35 1.35 0 0 0-1.064 0l-9.45 4.05a1.35 1.35 0 0 0 0 2.484l3.57 1.527a1.349 1.349 0 0 1 .481-.347l5.4-2.314a1.35 1.35 0 1 1 1.064 2.481l-3.681 1.579 2.619 1.122a1.35 1.35 0 0 0 1.062 0l9.45-4.05a1.35 1.35 0 0 0 0-2.481l-9.45-4.05zm-9.563 9.878 2.281.976V19.2a12.108 12.108 0 0 0-1.418-.235 1.35 1.35 0 0 1-1.202-1.202 15.005 15.005 0 0 1 .338-5.079zm8.087 9.688a12.185 12.185 0 0 0-3.106-2.212V14.82l2.454 1.053a4.05 4.05 0 0 0 3.191 0l7.436-3.187a14.885 14.885 0 0 1 .338 5.079 1.35 1.35 0 0 1-1.202 1.202 12.107 12.107 0 0 0-7.223 3.407 1.35 1.35 0 0 1-1.89 0zM8.1 24.3a1.35 1.35 0 0 0 1.35-1.35v-2.788a12.062 12.062 0 0 0-2.7-.961v3.749A1.35 1.35 0 0 0 8.1 24.3z" />
  </svg>
)

export const FolderIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={30}
    height={25}
    viewBox="0 0 30 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M27 3.125H15L12 0H3C1.335 0 .015 1.39.015 3.125L0 21.875C0 23.609 1.335 25 3 25h24c1.665 0 3-1.39 3-3.125V6.25c0-1.734-1.335-3.125-3-3.125Zm-1.5 12.5H21v4.688h-3v-4.688h-4.5V12.5H18V7.812h3V12.5h4.5v3.125Z"
      fill="#964DF4"
    />
  </svg>
)

export const PaperPlaneIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={25}
    height={27}
    viewBox="0 0 25 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M24.944 1.13a.866.866 0 0 0 .04-.472.84.84 0 0 0-.213-.417.77.77 0 0 0-.396-.224.743.743 0 0 0-.447.042L1.2 9.647h-.002l-.706.297a.788.788 0 0 0-.337.272.863.863 0 0 0-.075.857.811.811 0 0 0 .284.332l.64.429.002.003 7.804 5.237 2.484 4.116c1.207 1.878 1.207.23 1.207-.594 0-1.047.21-2.082.616-3.037.406-.955 1-1.809 1.742-2.505a6.946 6.946 0 0 1 2.562-1.532 6.684 6.684 0 0 1 2.932-.29l4.59-12.102ZM22.08 4.244 10.37 16.593l-.336-.558a.804.804 0 0 0-.24-.253l-.529-.354 11.71-12.349 1.84-.776-.735 1.941h-.001Z"
      fill="#F871C2"
    />
    <path
      d="M25 20.596c0 1.53-.577 2.997-1.602 4.078-1.026 1.082-2.417 1.69-3.867 1.69-1.45 0-2.841-.608-3.867-1.69a5.93 5.93 0 0 1-1.601-4.078 5.93 5.93 0 0 1 1.601-4.077c1.026-1.082 2.417-1.69 3.867-1.69 1.45 0 2.841.608 3.867 1.69A5.93 5.93 0 0 1 25 20.597Zm-3.114-2.766a.753.753 0 0 0-.592-.092.764.764 0 0 0-.276.137.81.81 0 0 0-.204.238l-1.828 3.213-.855-.9a.762.762 0 0 0-.553-.242.762.762 0 0 0-.553.241.848.848 0 0 0-.23.584c0 .218.083.428.23.583l1.21 1.274c.125.133.278.233.447.295a1.114 1.114 0 0 0 1.02-.132c.15-.103.275-.24.366-.4l2.086-3.669a.851.851 0 0 0 .088-.624.845.845 0 0 0-.13-.29.797.797 0 0 0-.226-.216Z"
      fill="#F871C2"
    />
  </svg>
)
